import { __assign, __rest } from "tslib";
import React from 'react';
import { useBiClickLogger } from '../hooks/useBiClickLogger';
var BiInput = function (_a) {
    var biData = _a.biData, innerRef = _a.innerRef, stopPropagation = _a.stopPropagation, props = __rest(_a, ["biData", "innerRef", "stopPropagation"]);
    var setTrackingRef = useBiClickLogger(biData, stopPropagation).setTrackingRef;
    return (React.createElement("input", __assign({}, props, { ref: function (node) {
            setTrackingRef(node);
            innerRef && innerRef(node);
        } })));
};
BiInput.displayName = 'BiInput';
export default BiInput;
//# sourceMappingURL=BiInput.js.map